import { baseApi } from '../apiProvider';
import {
  RequestAddBoard,
  RequestUpdateBoard,
} from '../models/request/requestBoard';
import {
  ResponseBoard,
  ResponseBoardType,
} from '../models/response/responseBoard';

const boardAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get board types
    getBoardTypes: builder.query<ResponseBoardType[], void>({
      query: () => ({
        url: '/v0/board-types',
        method: 'GET',
      }),
    }),
    // add a board
    addBoard: builder.mutation<ResponseBoard, RequestAddBoard>({
      query: (body: RequestAddBoard) => ({
        url: '/v0/boards',
        method: 'POST',
        body,
      }),
    }),
    // update board
    updateBoard: builder.mutation<ResponseBoard, RequestUpdateBoard>({
      query: (board: RequestUpdateBoard) => ({
        url: `/v0/boards/${board.id}`,
        method: 'PUT',
        body: board,
      }),
    }),
    // delete a board
    deleteBoard: builder.mutation<void, string>({
      query: (boardId: string) => ({
        url: `/v0/boards/${boardId}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBoardTypesQuery,
  useAddBoardMutation,
  useUpdateBoardMutation,
  useDeleteBoardMutation,
} = boardAPI;
